import { cacheDom } from '../utils/QuerySelectors.js'

const dom = {}
const qs = {
  share: 'data-share-article',
  shareText: 'data-share-text',
  shareUrl: 'data-share-url',
  muteButtons: 'data-mute-video',
}
const qsAll = {}

export const setupArticle = () => {
  cacheDom(dom, qs, qsAll)

  if (dom.share) {
    dom.share.addEventListener('click', () => {
      dom.shareUrl.select()
      dom.shareUrl.setSelectionRange(0, 99999)
      navigator.clipboard.writeText(dom.shareUrl.value)
      dom.shareText.innerText = 'Link copied'
      setTimeout(() => {
        dom.shareText.innerText = 'Share'
      }, 3000)
    })
  }

  if (dom.muteButtons) {
    const buttons = Array.isArray(dom.muteButtons) ? dom.muteButtons : [dom.muteButtons]
    buttons.forEach(button => {
      const selector = button.getAttribute('data-mute-video')
      const video = document.querySelector(selector)
      if (!video) return

      const muteIcon = button.querySelector('[data-icon-muted]')
      const unmuteIcon = button.querySelector('[data-icon-unmuted]')

      button.addEventListener('click', () => {
        video.muted = !video.muted
        button.title = video.muted ? 'Unmute' : 'Mute'

        if (muteIcon && unmuteIcon) {
          muteIcon.classList.toggle('hidden', !video.muted)
          unmuteIcon.classList.toggle('hidden', video.muted)
        }
      })
    })
  }
}
